﻿export {};

const advScope = window["adv"] ??= {};

const dateTimeOffset = new Date().getTimezoneOffset();

function blazorGetTimezoneOffset() {
  return dateTimeOffset;
}

advScope["blazorGetTimezoneOffset"] = blazorGetTimezoneOffset;

let wakeLock = null;

async function keepScreenOn() {
  if (wakeLock != null) {
    await resetWakeLockAsync();
  }

  const l = await navigator.wakeLock.request("screen");

  await registerWakeLockAsync(l);
}

async function registerWakeLockAsync(l) {
  if (wakeLock != null) {
    await resetWakeLockAsync();
  }

  wakeLock = l;

  l.addEventListener("release", () => wakeLock = null);

  document.addEventListener("visibilitychange", async () => {
    if (wakeLock == null) {
      return;
    }

    if (document.visibilityState === "visible") {
      l = await navigator.wakeLock.request("screen");

      await registerWakeLockAsync(l);
    } else {
      await resetWakeLockAsync();
    }
  });


  console.log("Wake Lock active");
}

async function resetWakeLockAsync() {
  if (wakeLock == null) {
    return;
  }

  await wakeLock.release();
}

advScope["keepScreenOn"] = keepScreenOn;

async function fullscreenPageAsync() {
  if (!document.fullscreenEnabled) {
    console.log("Your browser cannot use fullscreen right now");

    return false;
  }

  try {
    await document.documentElement.requestFullscreen();

    return true;
  } catch (e) {
    console.log('Unable to launch fullscreen', e);

    return false;
  }
}

advScope["fullscreenPage"] = fullscreenPageAsync;

//////////////////////////

////function handleBrowserIsSupported(checkBrowser: boolean) {
////  if (checkBrowser && !checkBrowserIsSupported()) {
////    setTimeout(() => window.document.write("Only Google Chrome and Microsoft Edge browsers supported."), 100);
////  }
////  else {
////    // blazor framework autostart is disabled, therefore we need to start it here
////    window["Blazor"].start({});
////  }
////}

////if (window.location.pathname.indexOf("/pos") === 0) {
////  // don't block the pos second screen

////  handleBrowserIsSupported(false);
////}
////else {
////  handleBrowserIsSupported(true);
////}

function initGridCellTooltips(gridElement: Element) {

  function applyTitles(root: Element) {
    root.querySelectorAll("td.k-table-td").forEach((td) => {
      const el = td as HTMLElement;
      const text = el.innerText?.trim();

      if (text && el.scrollWidth > el.offsetWidth) {
        if (el.getAttribute("title") !== text) {
          el.setAttribute("title", text);
        }
      }
      else {
        el.removeAttribute("title");
      }
    });
  }

  const observer = new MutationObserver(() => {
    applyTitles(gridElement);
  });

  observer.observe(gridElement, {childList: true, subtree: true});
}

advScope["initGridCellTooltips"] = initGridCellTooltips;

// blazor framework autostart is disabled, therefore we need to start it here
window["Blazor"].start();
